module.exports = __webpack_public_path__ + "img/southern-pines.f62b0a21.jpeg";